import { Page } from '@app/components/page/Page';
import { DeviceLocation, DeviceStatus } from '@app/modules/fleet/legacy/components/Device';
import { StreamerBoxModule } from '@app/modules/fleet/legacy/index';
import { streamerBoxStreamerBoxDevicesGet } from '@mi-front/api-v2';
import { Device } from '@mi-front/core';
import { AsyncView, Data, Title } from '@mi-front/ui';
import { Grid } from '@mui/material';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { DeviceRename } from './actions/DeviceRename';
import { DeviceRestart } from './actions/DeviceRestart';
import { DeviceSetCoords } from './actions/DeviceSetCoords';
import { ServicesList } from './services/ServicesList';

import { FormattedMessage } from 'react-intl';
import StreamerBoxIcon from '../../components/StreamerBoxIcon';
interface Props {
  readonly data: {
    readonly device: Device;
  };
}

/** Presentational device detail view with status, location and services. */
export function DeviceViewPageP(props: Props) {
  const { device } = props.data;
  const { $t } = useIntl();

  const title = $t(
    {
      id: 'streamBox.viewScreen.title',
      defaultMessage: 'Dispositivo {deviceName} / StreamBox',
    },
    {
      deviceName: device.name,
    },
  );

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<StreamerBoxIcon />}
        title={device.name}
        breadcrumbs={
          <Page.ModuleBreadcrumbs
            module={StreamerBoxModule}
            items={[
              {
                content: (
                  <>
                    <FormattedMessage id="streamBox.props.device" defaultMessage="Dispositivo" />{' '}
                    <span className="font-weight-medium">{device.name}</span>
                  </>
                ),
                active: true,
              },
            ]}
          />
        }
        actions={
          <>
            <DeviceRestart device={device} />
            <DeviceRename device={device} />
            <DeviceSetCoords device={device} />
          </>
        }
      />
      <Page.Content>
        <Grid container spacing={2}>
          <Grid item xs={12} md={2}>
            <Title>
              <FormattedMessage id="streamBox.props.id" defaultMessage="ID" />
            </Title>
            <Data>#{device.id}</Data>
          </Grid>
          <Grid item xs={12} md={2}>
            <Title>
              <FormattedMessage id="streamBox.props.status" defaultMessage="Estado" />
            </Title>
            <Data>
              <DeviceStatus device={device} />
            </Data>
          </Grid>
          <Grid item xs={12} md={8}>
            <Title>
              <FormattedMessage id="streamBox.props.location" defaultMessage="Ubicación" />
            </Title>
            <Data>
              <DeviceLocation device={device} />
            </Data>
          </Grid>
        </Grid>
        <ServicesList device={device} />
      </Page.Content>
    </Page>
  );
}

/** Device detail screen: loads a single stream-box device by route id. */
export function DeviceViewPage() {
  const { id } = useParams<{ id: string }>();
  const { $t } = useIntl();
  // TODO: handle 404
  return (
    <AsyncView
      promiseFn={() => streamerBoxStreamerBoxDevicesGet(String(id)) as Promise<Device>}
      loader={{
        message: $t({
          id: 'streamBox.viewScreen.loading',
          defaultMessage: 'Cargando dispositivo',
        }),
      }}
    >
      {(vp) => (
        <DeviceViewPageP
          data={{
            device: vp.data,
          }}
        />
      )}
    </AsyncView>
  );
}
